import { createFileRoute } from "@tanstack/react-router";
import { ReviewLpTemplate } from "~/features/reviewLp/ReviewLpTemplate";

export const Route = createFileRoute("/_authenticated/lp/review")({
  component: ReviewLpTemplate,
});
